/**
 * Domain Entity: ScratchpadItem
 * Represents a saved tourist center / spot in the user's travel scratchpad
 */
export class ScratchpadItem {
  constructor({
    centerId,
    customNote = '',
    order = 0,
    isVisited = false,
    addedAt = new Date().toISOString()
  }) {
    if (!centerId) {
      throw new Error('ScratchpadItem requires a valid centerId');
    }
    this.centerId = centerId;
    this.customNote = customNote;
    this.order = order;
    this.isVisited = isVisited;
    this.addedAt = addedAt;
  }

  updateNote(newNote) {
    this.customNote = (newNote || '').trim();
  }

  toggleVisited() {
    this.isVisited = !this.isVisited;
    return this.isVisited;
  }

  setOrder(newOrder) {
    this.order = Number(newOrder) || 0;
  }

  toJSON() {
    return {
      centerId: this.centerId,
      customNote: this.customNote,
      order: this.order,
      isVisited: this.isVisited,
      addedAt: this.addedAt
    };
  }

  static fromJSON(json) {
    if (!json || !json.centerId) return null;
    return new ScratchpadItem({
      centerId: json.centerId,
      customNote: json.customNote || '',
      order: json.order || 0,
      isVisited: !!json.isVisited,
      addedAt: json.addedAt || new Date().toISOString()
    });
  }
}
